import getCellClasses from './getCellClasses';
import getCellHTML from './getCellHTML';
import rights from '../../../../components/rights';

const COLUMNS_FOR_BUTTON_ROW = ['text', 'attachments', 'wbs', 'comments', 'overdue', 'overload'];

function createGridCell(instance, task, column, columnIndex) {
  const cellEl = document.createElement('div');

  const isLastColumn = Number(columnIndex) === instance.config.columns.length - 1;

  cellEl.style.cssText = `width:${column.width - (isLastColumn ? 1 : 0)}px;`;
  cellEl.innerHTML = getCellHTML(instance, task, column);
  cellEl.className = getCellClasses(instance, task, column, isLastColumn);

  if (instance.ganttDataApi.isExport() && cellEl.classList.contains('cell_readonly')) {
    cellEl.style.color = '#808080';
  }
  cellEl.setAttribute('data-type', column.data_type);
  cellEl.setAttribute('data-name', column.name);
  cellEl.setAttribute('data-column-index', columnIndex);
  cellEl.setAttribute('data-column-name', column.name);
  cellEl.setAttribute('data-id', task.id);

  return cellEl;
}

export default function (instance, row, task) {
  const columns = instance.getGridColumns();
  const isButtonRow = task.type === instance.config.types.button;

  columns.forEach((column, index) => {
    if (isButtonRow && !COLUMNS_FOR_BUTTON_ROW.includes(column.name)) return;
    if (!rights.project.hasCostRight(task.gantt_id) && (column.name === 'total_price' || column.name === 'actual_cost') && !instance.config.multiview) return;

    const gridCell = createGridCell(instance, task, column, index);

    gridCell && row.appendChild(gridCell);
  });

  return row;
}
